// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"383":"ef47d895","473":"5cc007dc"}[chunkId] + ".css";
};